import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from 'environments/environment';

export const MaintenanceGuard = (): boolean | UrlTree => {
	const router = inject(Router);

	if (!environment.maintenance) return true;

	return router.createUrlTree(['/maintenance']);
};

/** Only lets `/maintenance` open while maintenance is on; otherwise sends the user to `/task`. */
export const MaintenanceOnlyGuard = (): boolean | UrlTree => {
	const router = inject(Router);

	if (environment.maintenance) return true;

	return router.createUrlTree(['/task']);
};
